import { EmbedVideoBlockSchema } from '@blocksuite/affine-model';
import {
  BlockMarkdownAdapterExtension,
  type MarkdownAST,
} from '@blocksuite/affine-shared/adapters';
import { nanoid } from '@blocksuite/store';

import { createEmbedBlockMarkdownAdapterMatcher } from '../../common/adapters/markdown.js';
import { videoUrlRegex } from '../embed-video-model.js';

const isLinkNode = (node: MarkdownAST): node is MarkdownAST & { url: string } =>
  node.type === 'link' && typeof (node as any).url === 'string';

export const embedVideoBlockMarkdownAdapterMatcher =
  createEmbedBlockMarkdownAdapterMatcher(EmbedVideoBlockSchema.model.flavour, {
    toMatch: o => {
      if (!isLinkNode(o.node)) return false;
      const raw = o.node.url ?? '';
      const url = raw.trim().replace(/^`|`$/g, '');
      return videoUrlRegex.test(url);
    },
    toBlockSnapshot: {
      enter: (o, context) => {
        if (!isLinkNode(o.node)) return;
        // 如果链接位于表格内，交给 inline 视频渲染，避免生成额外的 embed block
        const parents = context.walkerContext.stack.map(s => s.node as any);
        const inTable = parents.some(
          p => p?.type === 'table' || p?.type === 'tableRow' || p?.type === 'tableCell'
        );
        if (inTable) return;

        const { walkerContext } = context;
        const raw = o.node.url ?? '';
        const url = raw.trim().replace(/^`|`$/g, '');
        walkerContext
          .openNode(
            {
              type: 'block',
              id: nanoid(),
              flavour: EmbedVideoBlockSchema.model.flavour,
              props: {
                url,
              },
              children: [],
            },
            'children'
          )
          .closeNode();
        walkerContext.skipAllChildren();
      },
    },
  });

export const EmbedVideoMarkdownAdapterExtension = BlockMarkdownAdapterExtension(
  embedVideoBlockMarkdownAdapterMatcher
);
